<template>
    <body class="class-1" id="dinein">
      <!-- header -->
      <PosAppHeader />

      <!-- main box -->
      <div class="main_box">
        <div class="left_panel dineintables ml-4">
          <div class="d-flex flex-column w-100">
            <div class="floorrow w-100 pr-4">
              <div class="d-flex flex-column flex-sm-row justify-content-between">
                <div class="floor d-flex flex-row justify-content-center justify-content-sm-start">
                  <div class="arrowcircle d-flex justify-content-center align-items-center" 
                       @click="prevFloor"
                       :class="{ 'active': currentFloorIndex > 0 }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 448 512">
                      <path d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l105.4 105.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H416C433.7 224 447.1 238.3 447.1 256z"/>
                    </svg>
                  </div>
                  <div class="floornum mr-1 ml-1">
                    <span>{{ currentFloorName }}</span>
                  </div>
                  <div class="arrowcircle d-flex justify-content-center align-items-center"
                       @click="nextFloor"
                       :class="{ 'active': currentFloorIndex < floors.length - 1 }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 448 512">
                      <path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"/>
                    </svg>
                  </div>
                </div>
                
                <div class="d-flex flex-column flex-sm-row">
                  <!-- <div class="totaltables p1-1 pr-1 mr-0 mr-sm-1 mr-md-4 d-flex justify-content-center">
                    <span style="color: #000;align-content: center;">{{ filteredOrders.length }}</span>
                  </div> -->
                  <div class="available p1-1 pr-1 mr-auto ml-auto mr-sm-2 ml-sm-0 mb-2 d-flex justify-content-center">
                    <span>Available: </span>
                    <span>{{ availableTables }}</span>
                  </div>
                  <div class="busy p1-1 pr-1 mr-auto ml-auto mr-sm-2 ml-sm-0 mb-2 d-flex justify-content-center">
                    <span>Busy: </span>
                    <span>{{ busyTables }}</span>
                  </div>
                  <div class="reserved p1-1 pr-1 mr-auto ml-auto mr-sm-2 ml-sm-0 mb-2 d-flex justify-content-center">
                    <span>Reserved: </span>
                    <span>{{ reservedTables }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="tables d-flex flex-row flex-wrap align-content-start">
              <!-- Dynamic table cards based on API data -->
              <div v-for="(order) in filteredOrders" :key="order.id" 
                   class="table-cards p-2" 
                   @click="navigateToPos(order)"
                   :class="{
                    'yellow': order.isPrint == 1,
                    'green': order.tablesold === 0 && order.isPrint != 1,
                    'red': order.tablesold === 1 && order.isPrint != 1
                  }">
                <div class="d-flex flex-column align-items-center">
                    <div class="symbol"></div>
                    <div class="table-number textcenter">
                      <span style="display: block;">{{ order.displayTableName }}</span>
                      <span style="display: block;">{{ order.totalPrice }}</span>
                    </div>
                </div>
              </div>
              <div v-if="filteredOrders.length === 0" class="no-tables-message">
                No tables found on this floor
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </template>
  
  <script>
  export default {
    data() {
      return {
        orders: [],
        menuVisible: false,
        floors: [],
        currentFloorIndex: 0,
        loading: true
      }
    },
    computed: {
      // Get unique floors from orders based on table_floor_id
      uniqueFloors() {
        const floorMap = new Map();
        
        this.orders.forEach(order => {
          if (order.table_floor_id && !floorMap.has(order.table_floor_id)) {
            floorMap.set(order.table_floor_id, {
              id: order.table_floor_id,
              name: order.floor_name || `Floor ${order.table_floor_id}`
            });
          }
        });
        
        // Convert map to array and sort
        return Array.from(floorMap.values()).sort((a, b) => a.id - b.id);
      },
      
      // Current floor name
      currentFloorName() {
        if (this.floors.length > 0 && this.currentFloorIndex < this.floors.length) {
          return this.floors[this.currentFloorIndex].name;
        }
        return 'All Floors';
      },
      
      // Filter orders by current floor
      filteredOrders() {
        if (this.floors.length === 0 || this.currentFloorIndex < 0) {
          return this.processedOrders;
        }
        
        const currentFloor = this.floors[this.currentFloorIndex];
        if (!currentFloor) return this.processedOrders;
        
        return this.processedOrders.filter(order => 
          order.table_floor_id && parseInt(order.table_floor_id) === parseInt(currentFloor.id)
        );
      },
      
      // Process orders with display names and sorting
      processedOrders() {
        // Create a map to count occurrences of each table name
        const tableNameCount = {};
        
        // First pass to count occurrences
        this.orders.forEach(order => {
          if (!tableNameCount[order.table_name]) {
            tableNameCount[order.table_name] = 0;
          }
          tableNameCount[order.table_name]++;
        });
        
        // Second pass to add suffixes where needed
        const tableNameIndex = {};
        const processed = this.orders.map(order => {
          if (!tableNameIndex[order.table_name]) {
            tableNameIndex[order.table_name] = 0;
          }
          tableNameIndex[order.table_name]++;
          
          // Only add suffix if there are duplicates
          const displayTableName = tableNameCount[order.table_name] > 1 
            ? `${order.table_name}.${tableNameIndex[order.table_name]}`
            : order.table_name;
            
          return {
            ...order,
            displayTableName
          };
        });

        // Sort the processed orders by table_name in ascending numerical order
        return processed.sort((a, b) => {
          // Convert table names to numbers for proper numerical sorting
          const tableA = parseInt(a.table_name) || 0;
          const tableB = parseInt(b.table_name) || 0;
          return tableA - tableB;
        });
      },
      
      // Calculate available tables
      availableTables() {
        return this.filteredOrders.filter(order => order.tablesold === 0 && order.isPrint != 1).length;
      },
      
      // Calculate busy tables
      busyTables() {
        return this.filteredOrders.filter(order => order.tablesold === 1 && order.isPrint != 1).length;
      },
      
      // Calculate reserved tables
      reservedTables() {
        return this.filteredOrders.filter(order => order.isPrint == 1).length;
      }
    },
    methods: {
      toggleMenu() {
        this.menuVisible = !this.menuVisible;
      },
      gotohome() {
      },
      navigateToPos(order) {
        if (!this.$hasPermission('edit orders')) {
          this.$toast.error('Not Permitted');
          return;
        }
        this.$router.push({ name: "PosComponent", params: { orderId: order.id, tableId: order.tableId } });
      },
      
      // Floor navigation methods
      nextFloor() {
        if (this.currentFloorIndex < this.floors.length - 1) {
          this.currentFloorIndex++;
        }
      },
      
      prevFloor() {
        if (this.currentFloorIndex > 0) {
          this.currentFloorIndex--;
        }
      },
      
      // Extract unique floors from orders
      extractFloors() {
        const floorMap = new Map();
        
        this.orders.forEach(order => {
          if (order.table_floor_id && !floorMap.has(order.table_floor_id)) {
            floorMap.set(order.table_floor_id, {
              id: order.table_floor_id,
              name: order.floor_name || `Floor ${order.table_floor_id}`
            });
          }
        });
        
        // Add "All Floors" option
        this.floors = Array.from(floorMap.values()).sort((a, b) => a.id - b.id);
        
        // Reset current floor index
        this.currentFloorIndex = this.floors.length > 0 ? 0 : -1;
      },
      
      async fetchDineInOrders() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken'); 
          const response = await fetch(`${this.$BASE_API_URL}/api/orders/types?types=2`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();
          if (data.status && data.data) {
            this.orders = data.data;
            this.extractFloors(); // Extract floors from orders
          }
        } catch (error) {
          console.error('Error fetching dine-in orders:', error);
        } finally {
          this.$root.isLoading = false;
          this.loading = false;
        }
      }
    },
    async created() {
      await this.fetchDineInOrders();
    }
  }
  </script>
  
  <style scoped>
  .green {
    background-color: #4CAF50; 
  }
  .red {
    background-color: #F44336; 
  }
  .yellow {
    background: #929b7f;
  }
  .table-cards {
    margin: 5px;
    border-radius: 8px;
    color: white;
    text-align: center;
    cursor: pointer;
    min-width: 100px;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .floor {
    cursor: pointer;
  }
  
  .arrowcircle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f0f0f0;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .arrowcircle.active {
    background-color: #4CAF50;
  }
  
  .arrowcircle.active svg {
    fill: white;
  }
  
  .arrowcircle svg {
    width: 16px;
    height: 16px;
    fill: #333;
  }
  
  .floornum {
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px;
    min-width: 120px;
    text-align: center;
  }
  
  .totaltables, .available, .busy, .reserved {
    padding: 5px 15px;
    border-radius: 5px;
    background-color: #f0f0f0;
    margin: 0 5px;
    min-width: 100px;
  }
  
  .no-tables-message {
    width: 100%;
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
  }
  
  @media (max-width: 768px) {
    .floornum {
      font-size: 14px;
      min-width: 80px;
    }
    
    .totaltables, .available, .busy, .reserved {
      min-width: 60px;
      font-size: 12px;
      padding: 5px 8px;
    }
    
    .table-cards {
      min-width: 70px;
      min-height: 70px;
      font-size: 12px;
    }
  }
  </style>